var map = {
	"./Acintyo.webp": 9663,
	"./DA.webp": 4149,
	"./Enorvision.webp": 1760,
	"./Gods.webp": 2305,
	"./HBF.webp": 1874,
	"./Indus.webp": 8427,
	"./Partner": 9862,
	"./Partner.css": 4471,
	"./Partner.jsx": 9862,
	"./Taiiki.webp": 3171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1310;